<template>
  <div>
    <ValidationObserver ref="form">
      <!-- Detalii teren -->
      <div class="columns">
        <div class="column is-4">
          <div class="field">
            <label class="label">Data inregistrare</label>
            <div class="control">
              <b-datepicker
                :date-parser="parser"
                v-model="sale.registrationDate"
                locale="ro"
                @input="dateSelected()"
                :unselectable-days-of-week="[0, 6]"
              >
              </b-datepicker>
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="field">
            <ValidationProvider
              name="Suprafata teren"
              rules="required"
              v-slot="{ errors }"
            >
              <b-field
                :type="errors[0] ? 'is-danger' : ''"
                :label="'Suprafata teren (mp)'"
                :message="errors[0]"
              >
                <b-input class="user-name-input" v-model="sale.surface" />
              </b-field>
            </ValidationProvider>
          </div>
        </div>
        <div class="column is-4">
          <div class="field">
            <ValidationProvider
              name="Suprafata teren"
              rules="required"
              v-slot="{ errors }"
            >
              <b-field
                :type="errors[0] ? 'is-danger' : ''"
                :label="'Pretul de vanzare'"
                :message="errors[0]"
              >
                <b-input
                  class="user-name-input"
                  v-model="sale.price"
                  step="0.01"
                  min="0"
                  max="10000000"
                  type="number"
                />
              </b-field>
            </ValidationProvider>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column is-4">
          <div class="field">
            <ValidationProvider
              name="Categoria de folosinta"
              rules="required"
              v-slot="{ errors }"
            >
              <b-field
                :type="errors[0] ? 'is-danger' : ''"
                :label="'Categoria de folosinta'"
                :message="errors[0]"
              >
                <b-dropdown v-model="sale.category" aria-role="list">
                  <template #trigger>
                    <b-button type="is-primary" icon-right="menu-down">
                      Categoria de folosinta ({{ sale.category }})
                    </b-button>
                  </template>

                  <b-dropdown-item value="Arabil" aria-role="listitem">
                    <span>Arabil</span>
                  </b-dropdown-item>

                  <b-dropdown-item value="Vii" aria-role="listitem">
                    <span>Vii</span>
                  </b-dropdown-item>
                  <b-dropdown-item value="Curti" aria-role="listitem">
                    <span>Curti</span>
                  </b-dropdown-item>
                </b-dropdown>
              </b-field>
            </ValidationProvider>
          </div>
        </div>
        <div class="column is-4">
          <div class="field">
            <ValidationProvider
              name="Tarla"
              rules="required"
              v-slot="{ errors }"
            >
              <b-field
                :type="errors[0] ? 'is-danger' : ''"
                :label="'Tarla'"
                :message="errors[0]"
              >
                <b-input
                  class="user-name-input"
                  v-model="sale.tarla"
                  type="text"
                />
              </b-field>
            </ValidationProvider>
          </div>
        </div>
        <div class="column is-4">
          <div class="field">
            <ValidationProvider
              name="Parcela"
              rules="required"
              v-slot="{ errors }"
            >
              <b-field
                :type="errors[0] ? 'is-danger' : ''"
                :label="'Parcela'"
                :message="errors[0]"
              >
                <b-input
                  class="user-name-input"
                  v-model="sale.parcela"
                  type="text"
                />
              </b-field>
            </ValidationProvider>
          </div>
        </div>
      </div>
      <!-- Informatii vanzator -->
      <div class="columns">
        <div class="column is-4">
          <div class="field">
            <ValidationProvider
              name="Nr. carte funciara"
              rules="required"
              v-slot="{ errors }"
            >
              <b-field
                :type="errors[0] ? 'is-danger' : ''"
                :label="'Nr. carte funciara'"
                :message="errors[0]"
              >
                <b-input
                  class="user-name-input"
                  v-model="sale.landRegistryNumber"
                  type="text"
                />
              </b-field>
            </ValidationProvider>
          </div>
        </div>
        <div class="column is-4">
          <div class="field">
            <ValidationProvider
              name="Nume si  vanzator"
              rules="required"
              v-slot="{ errors }"
            >
              <b-field
                :type="errors[0] ? 'is-danger' : ''"
                :label="'Nume si prenume vanzator'"
                :message="errors[0]"
              >
                <b-input
                  class="user-name-input"
                  v-model="sale.sellerFirstNameLastName"
                  type="text"
                />
              </b-field>
            </ValidationProvider>
          </div>
        </div>
        <div class="column is-4">
          <div class="field">
            <ValidationProvider
              name="Adresa vanzator"
              rules="required"
              v-slot="{ errors }"
            >
              <b-field
                :type="errors[0] ? 'is-danger' : ''"
                :label="'Adresa vanzator'"
                :message="errors[0]"
              >
                <b-input
                  class="user-name-input"
                  v-model="sale.sellerAddress"
                  type="text"
                />
              </b-field>
            </ValidationProvider>
          </div>
        </div>
      </div>
      <!-- Proces verbal -->
      <div class="columns">
        <div class="column is-4">
          <div class="field">
            <ValidationProvider name="Cumparator" v-slot="{ errors }">
              <b-field
                :type="errors[0] ? 'is-danger' : ''"
                :label="'Cumparator'"
                :message="errors[0]"
              >
                <b-input
                  class="user-name-input"
                  v-model="sale.buyer"
                  type="text"
                />
              </b-field>
            </ValidationProvider>
          </div>
        </div>
        <div class="column is-4">
          <div class="field">
            <label class="label">Data proces verbal procedura</label>
            <div class="control">
              <b-datepicker
                :date-parser="parser"
                v-model="sale.procesVerbalProcedura"
                locale="ro"
                :unselectable-days-of-week="[0, 6]"
              >
              </b-datepicker>
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="field">
            <label class="label">Data proces verbal finalizare</label>
            <div class="control">
              <b-datepicker
                :date-parser="parser"
                v-model="sale.procesVerbalFinalizare"
                locale="ro"
                :unselectable-days-of-week="[0, 6]"
              >
              </b-datepicker>
            </div>
          </div>
        </div>
      </div>
      <!-- Atasamente -->
      <div class="section-heading">Atasamente</div>
      <div class="columns">
        <div class="column is-8">
          <div v-if="attachmentUris.length" class="mb-3">
            <p class="has-text-weight-semibold mb-2">Documente atasate:</p>
            <div
              v-for="(att, index) in attachmentUris"
              :key="'att-' + index"
              class="is-flex is-align-items-center mb-2"
              style="gap: 0.5rem"
            >
              <b-icon icon="file-document-outline" size="is-small" />
              <a :href="att.URI || att.uri" target="_blank" class="is-flex-grow-1">{{
                att.name || att.fileName
              }}</a>
              <b-button
                size="is-small"
                type="is-danger is-outlined"
                icon-left="delete"
                @click="removeAttachment(index)"
              >
                Sterge
              </b-button>
            </div>
          </div>
          <b-field class="file is-primary">
            <b-upload v-model="newFiles" multiple class="file-label">
              <span class="file-cta">
                <b-icon class="file-icon" icon="upload"></b-icon>
                <span class="file-label">Selecteaza fisiere pentru atasare...</span>
              </span>
            </b-upload>
          </b-field>
          <div v-if="newFiles.length" class="mt-2">
            <div
              v-for="(file, index) in newFiles"
              :key="'new-' + index"
              class="is-flex is-align-items-center mb-1"
              style="gap: 0.5rem"
            >
              <b-icon icon="file-outline" size="is-small" />
              <span class="is-flex-grow-1">{{ file.name }}</span>
              <b-button
                size="is-small"
                type="is-danger is-outlined"
                icon-left="delete"
                @click="removeNewFile(index)"
              >
                Sterge
              </b-button>
            </div>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <b-field grouped>
            <div class="control">
              <b-button
                type="is-primary"
                native-type="submit"
                :loading="isUploadingAttachments"
                @click="handleAddSale"
                >Salvare</b-button
              >
            </div>
            <div class="control">
              <b-button type="is-danger is-outlined" @click.prevent="cancel()"
                >Anulare</b-button
              >
            </div>
          </b-field>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import { rawObject } from "@/helpers/utils";
import { pathOr } from "ramda";
import ElectronicRegisterSalesOffer from "@/services/electronicRegisterSalesOffer.service";
import BlobsService from "@/services/blobs.service";
import { getHolidays, HOLIDAY_FORMAT } from "@/config/holidays";
var moment = require("moment-business-days");
var momentBusinessDays = require("moment-business-days");

const HOLIDAYS_STORAGE_KEY = "sales_holidays";

function loadHolidays() {
  try {
    const stored = localStorage.getItem(HOLIDAYS_STORAGE_KEY);
    if (stored) return JSON.parse(stored);
  } catch (e) {}
  return getHolidays(new Date().getFullYear(), 2028);
}

moment.updateLocale("ro", {
  holidays: loadHolidays(),
  holidayFormat: HOLIDAY_FORMAT,
});

export default {
  name: "SalesAdd",
  methods: {
    parser(d) {
      return new Date(Date.parse(d));
    },
    dateSelected() {
      this.computeSaleDates(this.sale);
    },
    removeAttachment(index) {
      this.attachmentUris.splice(index, 1);
    },
    removeNewFile(index) {
      this.newFiles.splice(index, 1);
    },
    async uploadAttachments() {
      const { handleUploadSalesOfferAttachment } = BlobsService;
      const attachments = [];
      for (const file of this.newFiles) {
        const response = await handleUploadSalesOfferAttachment(file);
        if (response && response.data) {
          attachments.push({ name: file.name, fileName: file.name, URI: response.data });
        }
      }
      return attachments;
    },
    async handleAddSale() {
      this.$refs.form.validate().then(async (success) => {
        if (!success) {
          return;
        }

        if (this.newFiles.length > 0) {
          this.isUploadingAttachments = true;
          const newUris = await this.uploadAttachments();
          this.attachmentUris = [...this.attachmentUris, ...newUris];
          this.newFiles = [];
          this.isUploadingAttachments = false;
        }
        this.sale.attachments = [...this.attachmentUris];

        this.sale.username = this.$auth.user.email;
        this.sale.registrationDate = new Date(
          this.sale.registrationDate.getTime() -
            this.sale.registrationDate.getTimezoneOffset() * 60000
        ).toJSON();

        this.sale.procesVerbalProcedura = new Date(
          this.sale.procesVerbalProcedura.getTime() -
            this.sale.procesVerbalProcedura.getTimezoneOffset() * 60000
        ).toJSON();

        this.sale.procesVerbalFinalizare = new Date(
          this.sale.procesVerbalFinalizare.getTime() -
            this.sale.procesVerbalFinalizare.getTimezoneOffset() * 60000
        ).toJSON();

        if (this.editMode) {
          this.$emit("handleEditSale", rawObject(this.sale));
        } else {
          this.$emit("handleAddSale", rawObject(this.sale));
        }
      });
    },
    async getSale(id) {
      const { handleGetSale } = ElectronicRegisterSalesOffer;
      const response = await handleGetSale(id);
      const { data } = response;
      return data;
    },
    computeSaleDates(sale) {
      var procesVerbalProcedura = momentBusinessDays(
        sale.registrationDate
      ).businessAdd(45)._d;
      sale.procesVerbalProcedura = procesVerbalProcedura;
      sale.procesVerbalFinalizare = moment(procesVerbalProcedura)
        .add(30, "days")
        .toDate();
    },
    resetForm() {
      for (let [key, value] of Object.entries(this.sale)) {
        this.sale[key] = null;
      }
      this.$refs.form.reset();
      if (this.editMode) {
        this.getSaleOffer(this.id).then((response) => {
          this.sale = response;
        });
      }
    },
    cancel() {
      this.$router.push({ path: "/Sales" });
    },
  },
  data() {
    return {
      newFiles: [],
      attachmentUris: [],
      isUploadingAttachments: false,
      sale: {
        registrationDate: null,
        sellerAddress: null,
        sellerFirstNameLastName: null,
        surface: null,
        category: null,
        price: null,
        tarla: null,
        parcela: null,
        landRegistryNumber: null,
        buyer: null,
        procesVerbalProcedura: null,
        procesVerbalFinalizare: null,
        username: null,
        attachments: [],
      },
    };
  },
  created() {
    const id = parseInt(pathOr(null, ["params", "id"], this?.$route));
    this.id = id;
    if (this.id) {
      this.editMode = true;
      this.getSale(id).then((response) => {
        this.sale = response;
        this.sale.registrationDate = new Date(this.sale.registrationDate);
        this.sale.procesVerbalProcedura = new Date(
          this.sale.procesVerbalProcedura
        );
        this.sale.procesVerbalFinalizare = new Date(
          this.sale.procesVerbalFinalizare
        );
        if (this.sale.attachments && this.sale.attachments.length) {
          this.attachmentUris = this.sale.attachments.map((a) =>
            typeof a === "string"
              ? { name: a.split("/").pop(), fileName: a.split("/").pop(), URI: a }
              : a
          );
        }
      });
    } else {
      this.sale.registrationDate = new Date();
      this.computeSaleDates(this.sale);
    }
    const yearIndex = this.holidayYears.indexOf(this.currentYear);
    if (yearIndex !== -1) {
      this.activeHolidayTab = yearIndex;
    }
  },
};
</script>

<style scoped>
.section-heading {
  font-size: 0.95rem;
  font-weight: 600;
  color: #4a4a4a;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-top: 1.25rem;
  margin-bottom: 0.75rem;
  padding-bottom: 0.4rem;
  border-bottom: 2px solid #e8e8e8;
}
</style>
